export default __webpack_public_path__ + "static/media/background.ff1210e3.png";